var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10562",
    "data-name": "Group 10562",
    transform: "translate(-1065 -1496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-reader",
    "data-name": "Icon awesome-book-reader",
    d: "M24.75,6.75A6.75,6.75,0,1,0,18,13.5,6.75,6.75,0,0,0,24.75,6.75Zm-8.326,10.2C12.253,14.4,5.5,13.7,2.1,13.5a1.945,1.945,0,0,0-2.1,1.9V31.074a1.934,1.934,0,0,0,1.863,1.9c3.07.161,9.281.751,13.573,2.913a.979.979,0,0,0,1.44-.835v-17.3a.936.936,0,0,0-.451-.806ZM33.9,13.5c-3.4.193-10.157.9-14.328,3.449a.953.953,0,0,0-.451.818V35.052a.982.982,0,0,0,1.444.837c4.292-2.16,10.5-2.75,13.568-2.911A1.935,1.935,0,0,0,36,31.075V15.408A1.946,1.946,0,0,0,33.9,13.5Z",
    transform: "translate(1067 1498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830",
    "data-name": "Rectangle 17830",
    width: 40,
    height: 40,
    transform: "translate(1065 1496)",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCpd);
export default __webpack_public_path__ + "static/media/ic_cpd.e93811bfb0d11ffef66993875379dd71.svg";
export { ForwardRef as ReactComponent };